export const DUTY_PARENT_NOTE_MAX_LENGTH = 280;
